"use client";

import Link from "next/link";
import { BlogPost } from "../data/blogs";

interface BlogCardProps {
  blog: BlogPost;
}

export default function BlogCard({ blog }: BlogCardProps) {
  return (
    <div className="bg-surface-raised rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 border border-hairline flex flex-col h-full">
      <div className="relative h-48 w-full overflow-hidden group">
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex items-center text-sm text-ink-muted mb-3 gap-3">
          <span className="bg-blue-50 text-blue-600 px-2 py-1 rounded-md text-xs font-medium">{blog.readTime}</span>
          <time dateTime={blog.dateISO}>{blog.date}</time>
        </div>
        {/* h2 (not h3): these cards render directly after the /blogs page's <h1>
            with no intervening h2, so h3 would skip a level. */}
        <h2 className="text-xl font-bold text-ink mb-3 line-clamp-2 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
          <Link href={`/blogs/${blog.slug}`}>
            {blog.title}
          </Link>
        </h2>
        <p className="text-ink-muted mb-4 line-clamp-3 flex-grow">
          {blog.excerpt}
        </p>
        <div className="mt-auto pt-4 border-t border-hairline flex items-center justify-between">
          <span className="text-sm font-medium text-ink">{blog.author}</span>
          <Link 
            href={`/blogs/${blog.slug}`}
            className="text-blue-600 dark:text-blue-400 font-semibold text-sm hover:underline inline-flex items-center gap-1"
          >
            Read More
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}
